import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, AbstractControlDirective, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularMyDatePickerDirective, IMyDateModel } from 'angular-mydatepicker';
import * as moment from 'moment';
import { cValidators } from '../../../models/validator';
import { MatSelectChange } from '@angular/material/select';
import { DatepicketValue, InputForm } from '../../types/angular-datepicket';
import { FootToolbar } from '../../types/legacy/foot-toolbar';
import { FormConfig } from '../../types/legacy/form-config';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'iv-form',
  templateUrl: './iv-form.component.html',
  styleUrls: ['./iv-form.component.scss']
})
export class IvFormComponent implements OnInit {

  collapsed: boolean = true;
  public options: any = {
    alwaysShowCalendars: true,
    autoApply: true,
    locale: {
      format: 'dd/MM/yyyy',
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      customRangeLabel: 'Personalizado',
      firstDay: 1,
      daysOfWeek: [
        "Do",
        "Lu",
        "Ma",
        "Mi",
        "Ju",
        "Vi",
        "Sa"
      ],
      monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
    },
    ranges: {
      'Hoy': [moment(), moment()],
      'Último mes': [moment().subtract(1, 'month'), moment()],
      'Últimos 3 meses': [moment().subtract(3, 'month'), moment()],
      'Últimos 6 meses': [moment().subtract(6, 'month'), moment()],
      'Último año': [moment().subtract(12, 'month'), moment()],
    }
  };

  _columnsForm: FormConfig;
  errors: string[];

  @Input()
  set columnsForm(columnsForm: FormConfig) { this._columnsForm = (columnsForm); }
  get columnsForm(): FormConfig { return this._columnsForm; }

  @Input() showErrors: { [key: string]: boolean } = {
    onSubmit: true,
    inDialog: true
  };

  @Input() buttons: { [key: string]: boolean } = {
    save: true,
    clear: true
  }

  @Input() labels: { [key: string]: string } = {
    submit: 'Guardar',
    clear: 'Limpiar',
    dialogErrorClose: 'Cerrar',
    dialogErrorTitle: 'Errores'
  }

  @Input() colNo: number = 4;
  @Input() inModal: boolean = false;
  @Input() color: string;
  @Input() textColor: string;
  @Input() hidden: boolean = true;
  @Input() readonly: boolean = false;
  @Input('errorsForm') errorMessages: any = {
    'required': 'El campo es requerido',
    'minlength': 'El mínimo permitido ',
    'maxlength': 'El máximo de caracteres permitidos son ',
    'pattern': 'Solo se permite determinados carácteres. ',
    'email': 'El email no es correcto.',
    'password': 'La contraseña no es correcta.',
    'cif': 'El cif no es válido',
    'credits': 'Los créditos no pueden ser negativos'
  };
  @Output() onSaveClick = new EventEmitter();
  @Output() onClearClick = new EventEmitter();
  @Output() submitForm = new EventEmitter();
  @Output() onEnterKey = new EventEmitter();
  @Output() changeSimple = new EventEmitter();
  @Output() changeMultiple = new EventEmitter();
  @Output() changeMenu = new EventEmitter();
  @Output() iconClick = new EventEmitter();

  @Input('FormValidators') Form: FormGroup = this.fb.group({});

  @Input() footerbar: FootToolbar = {};
  @Input() showfooterbar: boolean = true;
  @Output() onFootbarClick = new EventEmitter();

  className: string = this.inModal ? 'w-100' : null;
  es: any;
  hidePass: boolean = true;
  keys: string[] = [];
  footerbarKeys: string[] = [];
  isSubmit: boolean = false;
  private control: AbstractControlDirective | AbstractControl;

  model: IMyDateModel = null;

  @ViewChild('dp') ngxdp: AngularMyDatePickerDirective;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.keys = this._columnsForm ? Object.keys(this._columnsForm) : [];
    this.Form = this.fb.group(this.parseConfig());
    this.hidden = false;
  }

  ngAfterViewInit() {
    if (this.footerbar) {
      this.footerbarKeys = Object.keys(this.footerbar);
    }
  }

  updateForm(columns: FormConfig) {
    this.columnsForm = columns;
    this.Form = this.fb.group(this.parseConfig(columns));
    this.keys = Object.keys(columns)
  }

  parseConfig(columns?: FormConfig) {
    const c = columns || this.columnsForm;
    const obj: any = {}
    for (const key in c) {
      const val = [];
      if (c[key].validators) {
        for (let i = 0; i < c[key].validators.length; i++) {
          if (cValidators[c[key].validators[i]]) {
            val.push(cValidators[c[key].validators[i]]);
          } else {
            val.push(Validators[c[key].validators[i]]);
          }
        }
        obj[(c[key].nombreService || key)] = [{ value: c[key].value || '', disabled: c[key].disabled || false }, Validators.compose(val)];
      } else {
        obj[(c[key].nombreService || key)] = [{ value: c[key].value || '', disabled: c[key].disabled || false }];
      }
    }
    return obj;
  }

  onClickFootbar(data: string) {
    this.onFootbarClick.emit({ key: data });
  }

  changeSelect(event: MatSelectChange | null, key: string | null) {
    this.changeSimple.emit({ data: this.columnsForm, event: event, key: key });
  }

  changeSelectMultiple(event: MatSelectChange | null, key: string | null) {
    this.changeMultiple.emit({ data: this.columnsForm, key: key, event: event.value });
  }

  changeSelectMenu(event: any, key: string | null) {
    this.columnsForm[key].value = event.value;
    this.columnsForm[key].childsSelected = event.childsSelected;
    this.changeMenu.emit({ data: this.columnsForm });
  }

  sendForm() {
    this.isSubmit = true;
    if (!this.Form.valid) {
      this.getErrors();
      return false;
    }
    this.onSaveClick.emit({ data: this.columnsForm });
  }

  clearForm(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.ngxdp?.clearDate();

    if (this.columnsForm) {
      for (let data in this.columnsForm) {
        if (this.columnsForm[data].type == 'checkbox') {
          const k = this.columnsForm[data].nombreService;
          const temp: { [key: string]: boolean } = {}
          temp[k] = true;
          this.Form.patchValue(temp);
        }
        if (this.columnsForm[data].type == 'select') {
          this.columnsForm[data].value = null;
          this.changeSelect(null, null);
        }
      }

      this.Form.reset();
      this.Form.updateValueAndValidity();
    }
    this.onClearClick.emit({ data: this.columnsForm });
  }

  enter() {
    this.onEnterKey.emit(true);
  }

  selectedDate(date: MatDatepickerInputEvent<Date>, input: InputForm, range: boolean, type: string) {
    let d = [
      new Date(date.value).toISOString(),
    ];
    input.value = d.toString();
    this.Form.get(input.nombreService).patchValue(input.value);
    this.columnsForm[input.nombreService].value = input.value;
  }

  selectedDateRange(value: DatepicketValue, input: InputForm, range: boolean) {
    let d = [
      new Date(value.dateRange.beginJsDate),
      new Date(value.dateRange.endJsDate)
    ];
    input.value = d;
    this.Form.get(input.nombreService).patchValue(input.value.toString());
  }

  getErrors() {
    this.Form.updateValueAndValidity();
    this.errors = [];
    for (let i = 0; i < this.keys.length; i++) {
      const key: string = this.columnsForm[this.keys[i]].nombreService || this.keys[i];
      const msg: (string[] | boolean) = this.getErrorMessage(key);
      if (msg) {
        this.Form.controls[key].markAsTouched();
        this.errors.push(this.columnsForm[this.keys[i]].label + ': ' + msg[0]);
      }
    }
  }

  getErrorMessage(key: string, index?: number) {
    this.control = this.Form.controls[key];
    if (!this.control) {
      return false;
    }
    return this.control.errors ? Object.keys(this.control.errors).map(field => this.errorMessages[field]) : false;
  }

  sumbitFormButton(event: Event): void {
    if (!this.readonly) {
      this.submitForm.emit(event.target);
    }
  }

  onIconClick(event: Event): void {
    this.iconClick.emit(event);
  }
}
